module.exports = __webpack_public_path__ + "img/6_zhucan.ce26c880.png";